/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function AILens({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M8 2.491A1.246 1.246 0 1 0 8 0a1.246 1.246 0 0 0 0 2.491Zm0 2.436a.858.858 0 1 0 0-1.716.858.858 0 0 0 0 1.716Zm.858 7.004a.858.858 0 1 1-1.716 0 .858.858 0 0 1 1.716 0ZM11.073 8a.858.858 0 1 0 1.716 0 .858.858 0 0 0-1.716 0Zm-7.004.858a.858.858 0 1 1 0-1.716.858.858 0 0 1 0 1.716Zm6.104-3.03a.858.858 0 1 0 1.213-1.214.858.858 0 0 0-1.213 1.213Zm-4.346 5.558a.858.858 0 1 1-1.213-1.213.858.858 0 0 1 1.213 1.213Zm4.346-1.213a.858.858 0 1 0 1.213 1.213.858.858 0 0 0-1.213-1.213Zm-5.56-4.346a.858.858 0 1 1 1.214-1.213.858.858 0 0 1-1.213 1.213ZM8 16a1.246 1.246 0 1 0 0-2.491A1.246 1.246 0 0 0 8 16Zm6.754-6.754a1.246 1.246 0 1 1 0-2.492 1.246 1.246 0 0 1 0 2.492ZM0 8a1.246 1.246 0 1 0 2.491 0A1.246 1.246 0 0 0 0 8Zm14.472-2.298a1.246 1.246 0 1 1-1.245-2.158 1.246 1.246 0 0 1 1.245 2.158ZM1.072 12a1.246 1.246 0 1 0 2.157-1.246A1.246 1.246 0 0 0 1.072 12Zm9.226 2.472a1.246 1.246 0 1 1 2.158-1.245 1.246 1.246 0 0 1-2.158 1.245ZM4 1.072a1.246 1.246 0 1 0 1.246 2.157A1.246 1.246 0 0 0 4 1.072Zm8.456 1.701a1.246 1.246 0 1 1-2.158-1.245 1.246 1.246 0 0 1 2.158 1.245ZM4 14.928a1.246 1.246 0 1 0 1.246-2.158A1.246 1.246 0 0 0 4 14.928Zm9.226-2.472a1.246 1.246 0 1 1 1.246-2.157 1.246 1.246 0 0 1-1.245 2.157ZM1.072 4a1.246 1.246 0 1 0 2.157 1.246A1.246 1.246 0 0 0 1.072 4Z" clipRule="evenodd" /></svg>;
}
;